export const TRANSACTIONS_RESULT_REQUEST = "TRANSACTIONS_RESULT_REQUEST";
export const TRANSACTIONS_RESULT_RESULT = "TRANSACTIONS_RESULT_RESULT";